// extracted by mini-css-extract-plugin
export default {"breadCrumbs":"styles_breadCrumbs__PNiPz","breadCrumbsLink":"styles_breadCrumbsLink__baldu"};